import './App.css';
import TodoWrapper from './components/TodoWrapper'

function App() {
  return (
    <div className="App">
 <TodoWrapper />
    </div>
  );
}

export default App;
